import { Action, Module, VuexModule } from "vuex-module-decorators";
import { SocialNews } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class SocialNewsModule extends VuexModule {
    @Action
    [SocialNews.showNews](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/social-news/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [SocialNews.listNews](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/social-news/list`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [SocialNews.saveNews](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/social-news/insert`,values, {headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [SocialNews.updateNews](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/social-news/update`,values, {headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [SocialNews.deleteNews](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/social-news/delete`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [SocialNews.uploadNewsBanner](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/social-news/uploadBanner`,values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [SocialNews.uploadArticleImage](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/social-news/uploadArticleImage`,values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [SocialNews.removeArticleImage](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/social-news/removeArticleImage`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}